import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CatalogNewItemPage } from "@/features/office/catalog-new";
import { CatalogNewGate } from "@/features/shared/feature-gates/catalog-new-gate";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  ...maskSearchFragment,
});

export const routeId = "/office/catalog-new/$catalogItemId";
export const Route = createFileRoute("/office/catalog-new/$catalogItemId")({
  validateSearch: searchSchema,
  component: () => (
    <CatalogNewGate>
      <CatalogNewItemPage />
    </CatalogNewGate>
  ),
});
